var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { onMounted, ref, watch } from "vue";
import { withPrefix } from "@/utils/redirect";
import { rethrowSimple } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridDatasets',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const historyStats = ref(null);
        function getCounts() {
            return __awaiter(this, void 0, void 0, function* () {
                historyStats.value = null;
                if (props.historyId) {
                    try {
                        const { data } = yield axios.get(withPrefix(`/api/histories/${props.historyId}?keys=nice_size,contents_active,contents_states`));
                        historyStats.value = data;
                    }
                    catch (e) {
                        rethrowSimple(e);
                    }
                }
            });
        }
        onMounted(() => {
            getCounts();
        });
        watch(() => props.historyId, () => getCounts());
        return { __sfc: true, props, historyStats, getCounts };
    }
});
